export const postIncidencesInitialState = {
	incidences: null,
	error: null,
	errorShow: false,
	loading: false,
};
